import { Component } from '@verndale/core';
import '../../scss/components/_navigation.scss';

class Navigation extends Component {
  setupDefaults() {
    this.dom = {
      triggers: this.el.querySelectorAll('.navigation__trigger-icon'),
      nav: this.el.querySelectorAll('.navigation__items')
    };
  }

  addListeners() {
    document.addEventListener('click', this.handleDocumentClick.bind(this));
  }

  handleDocumentClick(event: Event) {
    const nav = document.getElementById('main-navigation');
    let triggerClick = false;
    (this.dom.triggers as NodeList).forEach(trigger => {
      if (event.composedPath().includes(trigger as HTMLButtonElement)) {
        triggerClick = true;
        this.handleClick(trigger as HTMLButtonElement);
      }
    });

    if (!triggerClick) {
      if (!event.composedPath().includes(nav as HTMLElement)) {
        this.closeItem();
      }
    }
  }

  handleClick(trigger: HTMLButtonElement) {
    if (trigger.classList.contains('open')) {
      this.openItem(trigger);
    } else {
      this.closeItem(trigger);
    }
  }

  openItem(trigger: HTMLButtonElement) {
    trigger.setAttribute('aria-expanded', 'true');

    const nav = document.getElementById(trigger.getAttribute('aria-controls') as string);

    if (nav) {
      nav.classList.add('opened');
      if (nav.clientWidth < 768) {
        nav.classList.add('no-scroll');
      }
    }
  }

  closeItem(trigger: HTMLButtonElement | null = null) {
    if (trigger) {
      (trigger as HTMLButtonElement).setAttribute('aria-expanded', 'false');
    } else {
      (this.dom.triggers as NodeList).forEach(trigger => {
        if ((trigger as HTMLButtonElement).classList.contains('close')) {
          (trigger as HTMLButtonElement).setAttribute('aria-expanded', 'false');
        }
      });
    }

    const nav = document.getElementById('main-navigation');

    if (nav) {
      nav.classList.remove('opened', 'no-scroll');
    }
  }
}

export default Navigation;
